import { ContentTypes, downloadBlob, getApi, getBlob, postApi } from "../../common/actions/net.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import Logger from "../../common/util/Logger.js";
import { addRemoveLinesToTemporaryOrder } from "./order.js";
import { getExistingProductImage } from "./productImage.js";
import { getPropertyValue } from "../../common/util/changeUtils.jsx";
import { getSalesLineId } from "../util/orderUtil.js";

export const LOADING_CAMPAIGN = "LOADING_CAMPAIGN";
export const SET_CAMPAIGN_PRODUCTS = "SET_CAMPAIGN_PRODUCTS";
export const SET_CAMPAIGN_PRODUCT_IMAGE_URL = "SET_CAMPAIGN_PRODUCT_IMAGE_URL";
export const LOADING_NEW_PRODUCTS = "LOADING_NEW_PRODUCTS";
export const SET_NEW_PRODUCTS = "SET_NEW_PRODUCTS";
export const SET_NEW_PRODUCT_IMAGE_URL = "SET_NEW_PRODUCT_IMAGE_URL";
export const LOADING_BOUGHT_PRODUCTS = "LOADING_BOUGHT_PRODUCTS";
export const SET_BOUGHT_PRODUCTS = "SET_BOUGHT_PRODUCTS";
export const LOADING_MY_LISTS = "LOADING_MY_LISTS";
export const UPLOADING_MY_LIST = "UPLOADING_MY_LIST";
export const DOWNLOADING_MY_LIST_PDF = "DOWNLOADING_MY_LIST_PDF";
export const SET_MY_LISTS = "SET_MY_LISTS";
export const SET_CAMPAIGNS = "SET_CAMPAIGNS";
export const SET_MY_LIST_PRODUCT_IMAGE_URL = "SET_MY_LIST_PRODUCT_IMAGE_URL";
export const EDIT_MY_LIST = "EDIT_MY_LIST";
export const ADD_TO_MY_LISTS = "ADD_TO_MY_LISTS";
export const REMOVE_FROM_MY_LISTS = "REMOVE_FROM_MY_LISTS";
export const ADD_NEW_MYLIST = "ADD_NEW_MYLIST";
export const DELETE_MYLIST = "DELETE_MYLIST";
export const MOVE_FROM_TO_MY_LIST = "MOVE_FROM_TO_MY_LIST";
export const FIX_CHANGES_MYLIST = "FIX_CHANGES_MYLIST";
export const CLEAR_CHANGES_MYLIST = "CLEAR_CHANGES_MYLIST";
export const SWAP_REPLACEMENT_IN_MY_LIST = "SWAP_REPLACEMENT_IN_MY_LIST";
export const SORT_MY_LISTS = "SORT_MY_LISTS";
export const SET_SORTING_MY_LISTS = "SET_SORTING_MY_LISTS";



const setCampaignProducts = (products) => ({
    type: SET_CAMPAIGN_PRODUCTS,
    products
});

const setNewProducts = (products) => ({
    type: SET_NEW_PRODUCTS,
    products
});

const setBoughtProducts = (products) => ({
    type: SET_BOUGHT_PRODUCTS,
    products
});


/**
 * Loads campaign product for active customer
 * @returns {func}
 */
export function getCampaignProducts(){
    return async (dispatch, getState) => {
        try {
            if( getState().productLists.campaignProductsLoading ){
                return;
            }
            dispatch({
                type: LOADING_CAMPAIGN,
                loading: true,
            });
            //collect info regarding the campaign
            const {payload} = await dispatch(getApi("Product/GetCampaignProductsForCustomer"));
            //insert existing images
            for(let i=0; i<payload.length; i++){
                payload[i].imageUrl = getExistingProductImage(payload[i].productId);
            }

            //convert to default layout
            const prdList = payload.map( (prd) => {return {product:prd};});

            //store the resaults
            await dispatch( setCampaignProducts(prdList) );
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av kampanjeprodukter mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_CAMPAIGN,
                loading: false,
            });
        }
    };
}

/**
 * Loads campaign info for active customer (including names)
 * @returns {func}
 */
export function getCampaigns(){
    return async (dispatch, getState) => {
        try {
            if( getState().productLists.campaignProductsLoading ){
                return;
            }
            dispatch({
                type: LOADING_CAMPAIGN,
                loading: true,
            });

            //collect info regarding the campaign
            const {payload} = await dispatch(getApi("Product/GetActiveCampaignsForCustomer"));

            //insert existing images
            for(let i=0; i<payload.length; i++){
                const prods = payload[i].campaignProducts;

                //convert each product list to default layout (required by PrductView)
                const prdList = prods.map( (prd) => {return {product:prd};});
                payload[i].campaignProducts = prdList;

                for(let j=0; j<prods.length; j++){      
                    const prod = prods[j];          
                    prod.imageUrl = getExistingProductImage(prod.productId);
                }
            }
            
            //store the results
            await dispatch({
                type: SET_CAMPAIGNS,
                campaigns: payload
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av kampanjeprodukter mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_CAMPAIGN,
                loading: false,
            });
        }
    };
}


/**
 * Loads new products for active customer
 * @returns {func}
 */
export function getNewProducts(){
    return async (dispatch, getState) => {
        try {
            if( getState().productLists.newProductsLoading ){
                return;
            }
            dispatch({
                type: LOADING_NEW_PRODUCTS,
                loading: true,
            });
            //collect info regarding all the new products
            const {payload} = await dispatch(getApi("Product/NewProductsForCustomerQuery"));
            //insert existing images
            for(let i=0; i<payload.length; i++){
                payload[i].imageUrl = getExistingProductImage(payload[i].productId);
            }

            //convert to default layout
            const prdList = payload.map( (prd) => {return {product:prd};});

            await dispatch( setNewProducts(prdList) );
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av nyeprodukter mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_NEW_PRODUCTS,
                loading: false,
            });
        }
    };
}

/**
 * Loads recently bought products for active customer
 * @returns {func}
 */
export function getBoughtProducts(){
    return async (dispatch, getState) => {
        try {
            if( getState().productLists.boughtProductsLoading ){
                return;
            }
            dispatch({
                type: LOADING_BOUGHT_PRODUCTS,
                loading: true,
            });
            //collect info regarding all the new products
            const {payload} = await dispatch(getApi("Product/LastSoldProductsQuery"));
            //insert existing images
            for(let i=0; i<payload.length; i++){
                payload[i].imageUrl = getExistingProductImage(payload[i].productId);
            }

            //convert to default layout
            const prdList = payload.map( (prd) => {return {product:prd};});

            await dispatch( setBoughtProducts(prdList) );
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av kjøpte varer mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_BOUGHT_PRODUCTS,
                loading: false,
            });
        }
    };
}

/**
 * Loads recently bought products for active customer
 * @returns {func}
 */
export function getMyLists(){
    return async (dispatch, getState) => {
        try {
            if( getState().productLists.customListsLoading ){
                return;
            }
            dispatch({
                type: LOADING_MY_LISTS,
                loading: true,
            });
            //collect info regarding all the new productsl
            const {payload} = await dispatch(getApi("Product/MyListsQuery"));
            //insert existing images
            for(let i=0; i<payload.length; i++){
                payload[i]["lines_$"] = payload[i].lines;
                for(let j=0; j<payload[i].lines.length; j++){
                    const prd = payload[i].lines[j].product;
                    payload[i].lines[j].product.imageUrl = getExistingProductImage(prd.productId);
                    if(payload[i].lines[j].replacedProduct)
                    {
                        const repPrd = payload[i].lines[j].replacedProduct;
                        payload[i].lines[j].replacedProduct.imageUrl = getExistingProductImage(repPrd.productId);
                    }
                }
            }

            //Store all downloaded lists
            await dispatch({
                type: SET_MY_LISTS,
                lists: payload
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Laste lister mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_MY_LISTS,
                loading: false,
            });
        }
    };
}

/**
 * adds or remove products from the My List
 * @param {number} listId 
 * @param {object} product 
 * @param {number} qty
 * @returns {func}
 */
export function addRemoveProductToActiveList(listId, product, qty){
    return async (dispatch) => {
        try {
            const item = {
                myListId: listId,
                productId: product.productId,
                product: product,
                imageUrl: product.imageUrl,
                barcode: "",

            };
            
            if( qty>0 ){
                //Do change to redux data
                await dispatch({
                    type: ADD_TO_MY_LISTS,
                    listId,
                    item,
                    qty,
                });
            } else {
                //Do change to redux data
                await dispatch({
                    type: REMOVE_FROM_MY_LISTS,
                    listId,
                    productId: product.productId
                });
            }
            
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * adds or remove products from the My List
 * @param {number} listId 
 * @param {number} index1 
 * @param {number} index2
 * @returns {func}
 */
export function moveFromToInMyList(listId, index1, index2){
    return async (dispatch) => {
        try {
            await dispatch({
                type: MOVE_FROM_TO_MY_LIST,
                listId,
                index1,
                index2,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Sets the sorting mode
 * @param {boolean} sorting 
 * @returns {func}
 */
export function setMyListsSortingMode(sorting){
    return async (dispatch) => {
        try {
            await dispatch({
                type: SET_SORTING_MY_LISTS,
                sorting : sorting,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Swaps a replaced product with its replacement.
 * @param {number} listId 
 * @param {number} replacedProductId 
 * @param {number} replacementProductId
 * @returns {func}
 */
export function swapReplacedProductInMyList(listId, replacedProductId, replacementProductId){
    return async (dispatch, getState) => {
        try {

            // Check if replacement already exists in list
            const list = getState().productLists.customLists.find(l => l.myListId === listId);
            const alreadyThere = list["lines_$"].some(l => l.productId === replacementProductId); 

            if (alreadyThere){
                // just remove the replaced product
                const replacedLine =  list.lines.find(l => l.productId === replacedProductId);
                await dispatch(addRemoveProductToActiveList(listId, replacedLine.product, 0));
            }
            else {
                await dispatch({
                    type: SWAP_REPLACEMENT_IN_MY_LIST,
                    listId,
                    replacedProductId,
                    replacementProductId,
                });
            }
           
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Updates the sort order of the lists
 * @param {number} index1 
 * @param {number} index2
 * @returns {func}
 */
export function updateListSortOrder(index1, index2){
    return async (dispatch, getState) => {
        try {

            dispatch({
                type: UPLOADING_MY_LIST,
                uploading: true,
            });

            // Peform immediate update of state
            dispatch({
                type: SORT_MY_LISTS,
                index1: index1,
                index2: index2,
            });

            var lists = getState().productLists.customLists.filter(l => l.myListId > 0);

            const sortCmd = {
                listIds: lists.map((l, index) => { return {myListId: l.myListId, newSortOrder: index }; })
            };

            // Call API to set new sort order
            await dispatch(postApi("Product/UpdateMyListSortOrder", sortCmd));          
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Oppdatering lister mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: UPLOADING_MY_LIST,
                uploading: false,
            });
        }
    };
}


/**
 * Updates list with change
 * @param {number} listId 
 * @param {object} change 
 * @returns {func}
 */
export function changeCustomList(listId, change){
    return async (dispatch) => {
        try {
            await dispatch({
                type: EDIT_MY_LIST,
                listId,
                change
            });
            
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Creates a new local list
 * @param {object} history
 * @returns {func}
 */
export function createNewMyList(history){
    return async () => {
        try {
            history.replace("/order/lists/edit/-1");
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Updates a custome list for the user
 * @param {object} list
 * @param {object} history
 * @returns {func}
 */
export function UpdateMyList(list, history){
    return async (dispatch) => {
        try {
            dispatch({
                type: UPLOADING_MY_LIST,
                uploading: true,
            });
            let id = list.myListId;
            // If the list does not exist, create a new one
            if( list.myListId===-1 ) {
                const createMessage = {
                    name: getPropertyValue(list,"name"),
                };
                const {payload} = await dispatch(postApi("Product/CreateMyListCommand", createMessage));
                id = payload;
            }
            //make an update object
            const updatedList = {
                myListId: id,
                name: getPropertyValue(list,"name"),
                lines: getPropertyValue(list,"lines").map( (ele, index) => {
                    return {
                        productId: ele.product.productId,
                        newSortOrder: index,
                    };
                }),
            };
            //update the list with the lines
            await dispatch(postApi("Product/UpdateMyListCommand", updatedList));
            //if it is a new list, then add it to the lists
            if( list.myListId===-1 ){
                dispatch(changeCustomList(-1, {
                    name: "",
                    lines: [],
                }));
                dispatch({
                    type: ADD_NEW_MYLIST,
                    listItem: {
                        myListId: id,
                        name: getPropertyValue(list,"name"),
                        lines: getPropertyValue(list,"lines"),
                    },
                });
            }
            //move back to list page
            history.push("/order/lists");
            //clean up all changes and sets them as
            await dispatch({
                type: FIX_CHANGES_MYLIST,
                listId: id,
            });
            //remove all changes in My list
            dispatch({
                type: CLEAR_CHANGES_MYLIST,
            });
            //
            if( list.myListId==-1 ){
                dispatch( pushSystemMessage(`Opprettet liste ${getPropertyValue(list,"name")}`, messageType.message) );
            } else {
                dispatch( pushSystemMessage(`Oppdatert  liste ${getPropertyValue(list,"name")}`, messageType.message) );
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Oppdatering lister mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: UPLOADING_MY_LIST,
                uploading: false,
            });
        }
    };
}

/**
 * Updates a custome list for the user
 * @param {object} list
 * @returns {func}
 */
export function PrepareMyListForEdit(){
    return async (dispatch) => {
        try {
            //remove all changes in My list
            dispatch({
                type: CLEAR_CHANGES_MYLIST,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Creates a new list named "New List"
 * @param {object} list
 * @param {object} history
 * @returns {func}
 */
export function deleteMyList(list, history){
    return async (dispatch) => {
        try {
            const deleteMessage = {
                myListId: list.myListId,
            };
            await dispatch(postApi("Product/DeleteMyListCommand", deleteMessage));
            await dispatch({
                type: DELETE_MYLIST,
                myListId: list.myListId,
            });
            dispatch( pushSystemMessage(`Slett liste ${getPropertyValue(list,"name")}`, messageType.message) );
            history.replace("/order/lists");
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Slette liste mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Adds all products in line to current order
 * @param {object} list
 * @param {object} activeOrder 
 * @returns {func}
 */
export function addMyListToOrder(list, activeOrder){
    return async (dispatch, getState) => {
        try {
            if( list.length===0 ){
                return;
            }
            const prdLine = [];
            for(let i=0; i<list.length; i++){
                const newLine = (getState().order.active.unConfirmedOrderLines && getState().order.active.unConfirmedOrderLines.find( (item) => item.productId===list[i].product.productId)) ||
                    (getState().order.active.orderLines && getState().order.active.orderLines.find( (item) => item.productId===list[i].product.productId));
                prdLine.push({
                    productId: list[i].product.productId,
                    qty: (newLine?newLine.orderedQty:0)+1,
                    salesLineId: getSalesLineId(activeOrder, list[i].product.productId),
                });
            }
            dispatch( addRemoveLinesToTemporaryOrder(activeOrder.shipmentId, activeOrder.distributionRouteId, activeOrder.deliveryDate, prdLine) );
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Downloads a pdf with barcodes for current list
 * @param {string} token
 * @param {number} myListId
 * @param {string} listName
 * @returns {func}
 */
export function downloadListPdf(token, myListId, listName){
    return async (dispatch) => {
        try {
            dispatch({
                type: DOWNLOADING_MY_LIST_PDF,
                downloading: true,
            });

            const blob = await getBlob("Product/MyListPdfQuery", {myListId}, token, ContentTypes.JSON, ContentTypes.PDF, false);
            downloadBlob(blob, `${listName}.pdf`, ContentTypes.PDF);

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Nedlasting av pdf mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: DOWNLOADING_MY_LIST_PDF,
                downloading: false,
            });
        }
    };
}